import styled from 'styled-components';

import { ArchivedRowStyle, StyledTable } from 'components/DataTable/DataTable.style';

// A fixed header makes antd fix the layout, splitting the popover's width evenly; a sorted and
// filtered column is then too narrow for its title, which breaks mid-word. Size columns to content.
export const StyledPopoverTable = styled(StyledTable).attrs({ tableLayout: 'auto' })`
  .ant-table-row {
    background-color: ${({ theme }) => theme.secondaryBackgroundColor};
  }
`;

export const StyledTasksPopoverTable = styled(StyledPopoverTable)`
  ${ArchivedRowStyle}
`;
